export const useOfflineRedirect = () => null;
